module.exports = __webpack_public_path__ + "static/media/cancel.d2204020.png";